import { Button } from '@lms/ui/button';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogTrigger,
} from '@lms/ui/dialog';
import { ClipboardCopy, QrCodeIcon } from 'lucide-react';
import { useState } from 'react';
import { useTranslations } from 'use-intl';

export function QrCodeButton({ slug, code }: { slug: string; code: string }) {
  const [open, setOpen] = useState(false);
  const t = useTranslations('admin');
  const link = `https://${window.location.host}/${slug}/login?code=${code}`;

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button variant="ghost" size="icon" onClick={() => setOpen(true)}>
          <QrCodeIcon />
        </Button>
      </DialogTrigger>
      <DialogContent>
        <DialogTitle>{t('qr_code')}</DialogTitle>
        <div className="grid grid-cols-2">
          {/* Same-origin QR image straight from the backend; the Next app
              proxied this via app/api/qrcode. */}
          <img
            src={`/api/v1/qr?data=${encodeURIComponent(link)}&size=200`}
            alt={t('qr_code')}
          />
          <div className="flex items-center justify-center text-3xl font-semibold tracking-wider">
            <div>{code}</div>
          </div>
        </div>
        <div className="flex flex-col items-center justify-center">
          <div>{t('code_link')}</div>
          <div className="text-muted-foreground">
            {link}
            <Button
              onClick={() => navigator.clipboard.writeText(link)}
              variant="ghost"
              size="icon"
              title={t('copy_to_clipboard')}
            >
              <ClipboardCopy className="h-4 w-4" />
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
